import {
  MLD_DEFAULT_PER_PAGE,
  MLD_SEARCH_MIN_LENGTH,
  MldCountsParams,
  MldCountsQuery,
  MldListParams,
  MldListQuery,
} from './types';

/**
 * Builds the query strings of the `abo/mld` list and counts routes. Shared by
 * the actions and the React Query keys, so the same request always has the
 * same key.
 *
 * - `q` is trimmed and dropped below 2 characters: DS answers 400 otherwise.
 * - `cancelsSoon` / `trialSale` are sent only when `true`: a `false` would
 *   travel as the string "false", and must never be read as a filter.
 * - Unknown keys (a `status` or a sort handed to the counts) are never copied.
 */
export const buildMldCountsQuery = (
  params: MldCountsParams = {},
): MldCountsQuery => {
  const query: MldCountsQuery = {};
  if (params.family) {
    query.family = params.family;
  }
  if (params.cancelsSoon === true) {
    query.cancelsSoon = true;
  }
  if (params.trialSale === true) {
    query.trialSale = true;
  }
  const q = (params.q ?? '').trim();
  if (q.length >= MLD_SEARCH_MIN_LENGTH) {
    query.q = q;
  }
  return query;
};

/**
 * The list query: the counts filters plus `status`, a 0-based `page` and the
 * sort. `sortBy` / `sortDir` are sent only when set, so an unsorted request
 * keeps DS's default order and its cache key. The counts query never carries
 * them: a header click must not refetch the tab counts.
 */
export const buildMldListQuery = (params: MldListParams = {}): MldListQuery => {
  const {
    status,
    page = 1,
    perPage = MLD_DEFAULT_PER_PAGE,
    sortBy,
    sortDir,
  } = params;
  const query: MldListQuery = {
    page: Math.max(0, page - 1),
    perPage,
  };
  if (status) {
    query.status = status;
  }
  if (sortBy) {
    query.sortBy = sortBy;
  }
  if (sortDir) {
    query.sortDir = sortDir;
  }
  return { ...query, ...buildMldCountsQuery(params) };
};
